<template>
  <div>
    <div class="bg-white shadow p-2 mb-3">

			<div class="row">
        <div class="col">
          <v-select
            v-model="selectedYear"
            :options="listYears"
            @input="onYearChange" />
        </div>
        <div class="col">
          <v-select
            v-model="selectedMonth"
            :options="listMonths"
            @input="onMonthChange" />
        </div>
      </div>

      <div class="row mt-2">
        <div class="col">
          <button class="btn btn-sm btn-primary btn-icon-split" @click="onRefresh" :disabled="isLoading">
            <span class="icon"><i class="fas fa-search" /></span>
            <span class="text">Cari <b-spinner small v-show="isLoading" /></span>
          </button>
        </div>

        <div class="col text-right">
          <button class="btn btn-sm btn-info btn-icon-split text-dark mr-2" @click="onRefresh" :disabled="isLoading">
            <span class="icon"><i class="fas fa-print" /></span>
            <span class="text">Cetak <b-spinner small v-show="isLoading" /></span>
          </button>

          <button class="btn btn-sm btn-success btn-icon-split text-dark" @click="onRefresh" :disabled="isLoading">
            <span class="icon"><i class="fas fa-file-excel" /></span>
            <span class="text">Export Excel <b-spinner small v-show="isLoading" /></span>
          </button>
        </div>
      </div>

    </div>


    <AppTable :apiUrl="apiUrl" :fields="tableFields" :search="search" @onSelectItem="selectedItem = $event" />
  </div>
</template>

<script>
import AppToolbox from '@/components/app/AppToolbox.vue'
import AppTable from '@/components/app/AppTable.vue'

const LIST_MONTHS = [
  'Januari',
  'Februari',
  'Maret',
  'April',
  'Mei',
  'Juni',
  'Juli',
  'Agustus',
  'September',
  'Oktober',
  'November',
  'Desember'
]

export default {
  components: { AppToolbox, AppTable },
  mounted() {
    this.onRefresh()
    this.loadOptionData()
  },
  data() {
    return {
      apiUrl: '/salary-internal-contract',
      tableFields: [
        { key: 'index', label: 'No.' },
        { key: 'Name', label: 'Nama', sortable: true, stickyColumn: true, variant: 'light' },
        { key: 'FirstAssignment', label: 'TMT Awal' },
        { key: 'LastAssignment', label: 'TMT Baru' },
        { key: 'WorkingYears', label: 'Masa THN' },
        { key: 'WorkingMonths', label: 'Masa BLN' },
        { key: 'Education', label: 'Pendidikan' },
        { key: 'Salary', label: 'Besarnya Honor', formatter: value => value ? $helper.formatRupiah(value) : '' },
        { key: 'TrueSalary', label: 'Jumlah Bersih', formatter: value => value ? $helper.formatRupiah(value) : '' },
        { key: 'AccountNumber', label: 'No. Rekening' }
      ],
      selectedItem: null,
      search: '',
      listYears: [
        (new Date()).getFullYear() - 3,
        (new Date()).getFullYear() - 2,
        (new Date()).getFullYear() - 1,
        (new Date()).getFullYear(),
        (new Date()).getFullYear() + 1,
        (new Date()).getFullYear() + 2,
        (new Date()).getFullYear() + 3
      ],
      listMonths: LIST_MONTHS,
      filter: {
        year: (new Date()).getFullYear(),
        month: LIST_MONTHS[(new Date()).getMonth()]
      }
    }
  },
  computed: {
    isLoading () {
      return this.$store.state.isLoading
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },
    loadOptionData () {
      this.$axios.all([
        this.$axios.get('/logistic-item'),
        this.$axios.get('/logistic-supplier')
      ]).then(this.$axios.spread((...res) => {
        this.listItem = res[0].data
        this.listSupplier = res[1].data
      }))
    }
  }
}
</script>
